import { render } from "./LoginPage.vue?vue&type=template&id=5b3d9646&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=5b3d9646&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__